<template>
  <div class="program-form">
    <div class="description" v-html="description"></div>
    <hr v-if="description" />

    <div class="row">
      <div class="col-sm-12 col-lg-8">
        <div
          v-for="(question, idx) in questions"
          :key="question.text"
          class="questions"
        >
          <ProgramFormField
            ref="fields"
            :editable="editable"
            :show-invalid-state="showInvalidState"
            :question-no="(idx + 1)"
            :question="question"
            :prefilled-with="prefilledQuestions[question.id]"
            @change="fieldDidChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProgramFormField from 'modules/dashboard-organizer/ProgramFormField.vue'
import _ from 'lodash'

export default {
  components: { ProgramFormField },
  props: {
    questions: { type: Array, default: () => [] },
    description: { type: String, default: '' },
    showInvalidState: { type: Boolean, default: false },
    editable: { type: Boolean, default: true },
    prefilledQuestions: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      form: [],
    }
  },
  computed: {
    fields() {
      return this.$refs.fields || []
    },
    isValid() {
      return this.fields.every((f) => f.isValid)
    },
    questionsToFieldsMap() {
      const map = {}
      this.fields.forEach((field) => {
        map[field.question.id] = field
      })
      return map
    },
  },
  methods: {
    getFormData() {
      const formData = this.fields.map((field, idx) => ({
        question: this.questions[idx],
        ...field.getAnswerData(),
      }))
      return formData
    },
    fieldDidChange(field) {
      this.$emit('change-field', field)
      this.$emit('change', this.getFormData(), field)
    },

    setAnswers(answers) {
      const fillUnanswered = ({ answers, questions }) => {
        const newAnswers = { ...answers }
        questions.forEach((question) => {
          if (!newAnswers[question.id]) {
            newAnswers[question.id] = {}
          }
        })
        return newAnswers
      }

      answers = fillUnanswered({ answers, questions: this.questions })
      _.toPairs(answers).forEach((pair) => {
        const [questionId, answer] = pair
        this.setAnswerForSingleQuestion({ questionId, answer })
      })
    },

    setAnswerForSingleQuestion({ questionId, answer }) {
      const field = this.questionsToFieldsMap[questionId]
      if (!field) return
      field.setAnswer({
        data: {},
        ...answer,
      })
    },
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';

.program-form {
  .description {
    margin: 16px 0 16px 36px;
    font-size: 16px;
    color: $grey90;
  }
  .questions {
    .question-text {
      font-weight: 300;
      font-size: 24px;
    }
  }
  .row {
    display: flex;
    margin-top: 40px;
    div {
      justify-content: center;
    }
  }
}
</style>
